/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantVlcrProvisionEdr } from './tenantVlcrProvisionEdr';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ByolEdr } from './byolEdr';


export interface TenantRansomwareRecoveryActivationSpec { 
    byol?: ByolEdr;
    vlcr_provider?: CloudProvidersEnum;
    vlcr_provisioned?: TenantVlcrProvisionEdr;
    /**
     * Cloud Provider Region ID
     */
    vlcr_region?: string;
}
export namespace TenantRansomwareRecoveryActivationSpec {
}


